import AtomH2 from "Components/Atoms/H2";
import AtomSubtitle2 from "Components/Atoms/Subtitle2";
import AtomDescription1 from "Components/Atoms/Description1";

import AtomNowThumbnail from "Components/Atoms/NowList/Thumbnail";
import styled from "styled-components";

import * as Types from "Types";

export interface NowContent extends Types.Default {
   title: string;
   thumbnail_uri: string;
   subtitles: string;
   description: string;
}

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   position: relative;
   padding: 30px 15px 30px 15px;
   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
   max-width: 100%;
   ${({ css }) => css}
`;

const ChildThumbnail = styled(AtomNowThumbnail)`
   width: 240px;
   max-width: 100%;
   box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
`;

const ChildTitle = styled(AtomH2)`
   line-height: 39px;
   margin-top: 40px;
   margin-bottom: 17px;
   text-align: center;
`;

const ChildSubtitle = styled(AtomSubtitle2)`
   line-height: 22px;
   margin-bottom: 6px;
`;

const ChildDescription = styled(AtomDescription1)`
   line-height: 23px;
   margin-top: 18px;
`;

function NowList(props: NowContent) {
   const subtitles = JSON.parse(props.subtitles);

   return (
      <Wrap css={props.css}>
         <ChildThumbnail src={props.thumbnail_uri}></ChildThumbnail>
         <ChildTitle>{props.title}</ChildTitle>
         {subtitles.map((subtitle: any) => (
            <ChildSubtitle key={subtitle.key}>
               {subtitle.key} : {subtitle.content}
            </ChildSubtitle>
         ))}
         <ChildDescription>{props.description}</ChildDescription>
      </Wrap>
   );
}

export default NowList;
